// extracted by mini-css-extract-plugin
export default {"container":"PhoneNumberInput_container__4ndKl"};